<div ngModelGroup #videoAccessControlGroup="ngModelGroup" name="videoAccessControlGroup">
	<div [ngClass]="styles.rowDivider">
		<vb-ui-form-group>
			<label #uiLabel *ngIf="!hideLabel">{{ 'Media_Videos_Settings_AccessControl' | translate }}</label>
			<div uiControl>
				<!-- Public Toggle -->
				<div class="box-block" [ngClass]="styles.toggleContainer" *ngIf="isPublicToggleVisible">
					<label for="publicACLToggle">
						<span>{{ 'Media_Videos_Settings_Public' | translate }}</span>
					</label>
					<vb-toggle-button name="accessControlPublic" [toggleId]="'publicACLToggle'" [disabled]="!hasContentCreatorRights" [(ngModel)]="isPublic" (change)="onPublicChange()">
					</vb-toggle-button>
				</div>

				<!-- Public Password-->
				<div class="animate-if" *ngIf="isPublic && MediaFeatures.accountFeatures.enablePublicVideoAccess">
					<vb-ui-form-group>
						<label for="vsPassword" #uiLabel>{{ 'Password_Optional' | translate }}</label>
						<div uiControl>
							<input type="text" name="password" id="vsPassword" #password="ngModel" [disabled]="!hasContentCreatorRights" [(ngModel)]="model.password" (change)="onChangeAcl()" pattern="^\S+$" vbUiTextInput>
							<div class="row" role="alert" *ngIf="password.invalid" vbUiErrorMessage uiValidation>
								<label class="control-label" [hidden]="!(password.errors?.pattern)">
									{{ 'Media_Videos_PasswordSpaceCharNotAllowed' | translate }}
								</label>
							</div>
						</div>
					</vb-ui-form-group>
				</div>

				<!--Public Password Warning-->
				<div class="animate-if public-password-warning" [ngClass]="styles.publicPasswordWarning" *ngIf="isPublic && MediaFeatures.accountFeatures.enablePublicVideoAccess">
					<div layout="row" layout-wrap="false" class="theme-primary-txt">
						<span class="glyphicons warning_sign"></span>
						<span flex="fill">{{ 'Media_Videos_PublicPasswordWarning' | translate }}</span>
					</div>
				</div>

				<!-- All Internal Users Toggle -->
				<div class="box-block" [ngClass]="styles.toggleContainer">
					<label for="allInternalUsersACLToggle" #uiLabel [tooltip]="allUsersTooltip | translate" [containerClass]="styles.accessControlTooltip" [isOpen]="ready && allUsersTooltip" triggers="none" placement="left">
						<span>{{ 'Media_Videos_Settings_AllUsers' | translate }}</span>
					</label>
					<vb-toggle-button uiControl name="accessControlAllUsers" #accessControlAllUsers="ngModel" [toggleId]="'allInternalUsersACLToggle'" [disabled]="isPublic || !hasContentCreatorRights" [(ngModel)]="isAllInternalUsers" (change)="onAllInternalChange()">
					</vb-toggle-button>
				</div>
			</div>
		</vb-ui-form-group>
	</div>

	<!--Access Control Entities-->
	<div class="margin-top-15" [ngClass]="styles.accessControlEntities" *ngIf="model?.accessControlEntities">
		<div [ngClass]="styles.accessControlEntitiesHeader">
			<span>{{ (hasContentCreatorRights ? 'Specify_Users_Groups_Channels' : 'Specify_Channels') | translate }}</span>
			<span [ngClass]="styles.restrictedUseMessage" *ngIf="!hasContentCreatorRights">{{ 'Media_Videos_Settings_CannotAddUsersOrGroups' | translate }}</span>
		</div>

		<ng-template #accessEntityOptionRow let-item="item" let-insight="insight">
			<access-entity-option-row [item]="item" [insight]="insight"></access-entity-option-row>
		</ng-template>

		<ng-template #accessEntityAssignedRow let-item="item" let-insight="insight">
			<access-entity-assigned-row [item]="item" [insight]="insight"></access-entity-assigned-row>
		</ng-template>

		<insight uiControl name="accessControlEntities" [insightOptions]="accessControlInsightOptions" [(ngModel)]="model.accessControlEntities" (ngModelChange)="onChangeAcl()" [optionTemplate]="accessEntityOptionRow" [assignedTemplate]="accessEntityAssignedRow">
		</insight>
	</div>
</div>
